export const GOOGLE_CLIENT_ID = process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID!;
export const NEXT_PUBLIC_GOOGLE_CLIENT_ID = GOOGLE_CLIENT_ID;
export const GOOGLE_DRIVE_SCOPES = [
    // ── Identity ──────────────────────────────────────────
    "openid",
    "https://www.googleapis.com/auth/userinfo.profile",
    "https://www.googleapis.com/auth/userinfo.email",

    // ── Calendar (already present) ────────────────────────
    "https://www.googleapis.com/auth/calendar.readonly",
    "https://www.googleapis.com/auth/calendar.freebusy",
    "https://www.googleapis.com/auth/calendar.events",

    // ── Drive (existing) ──────────────────────────────────
    "https://www.googleapis.com/auth/drive.metadata.readonly",
    "https://www.googleapis.com/auth/drive.readonly",        // keep if you still need generic Drive access
    "https://www.googleapis.com/auth/drive.file",

    // ── **NEW for Meet artifacts (recordings + transcripts)** ──
    "https://www.googleapis.com/auth/drive.meet.readonly",    // limited to Meet-generated files

    // ── **NEW for Meet REST** ──
    "https://www.googleapis.com/auth/meetings.space.created", // create/manage the spaces you spin up
    "https://www.googleapis.com/auth/meetings.space.readonly",// read spaces + pull transcripts

    // ── **NEW for reading the raw Docs transcript (optional)**
    "https://www.googleapis.com/auth/documents.readonly",

    // ── Forms API ─────────────────────────────────────────
    "https://www.googleapis.com/auth/forms.body",
    "https://www.googleapis.com/auth/forms.body.readonly",
    "https://www.googleapis.com/auth/forms.responses.readonly",

    // ── Tasks API ─────────────────────────────────────────
    "https://www.googleapis.com/auth/tasks",                 // swap for .readonly if you never write tasks
].join(' '); 